import { dataGatewaySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGatewaySolid = /*#__PURE__*/createIcon(dataGatewaySolid)
export default IconGatewaySolid
